export { default } from './OrderCompletedPurchase';
